import get from 'lodash/get';
import fromPairs from 'lodash/fromPairs';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import isFunction from 'lodash/isFunction';
import without from 'lodash/without';
import uniq from 'lodash/uniq';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import sortBy from 'lodash/sortBy';
import flatten from 'lodash/flatten';
import jwt_decode from 'jwt-decode';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isToday from 'dayjs/plugin/isToday';
import dayjs from 'dayjs';
import Cookies from 'universal-cookie';
import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  DJANGO_LANGUAGE,
  PAGE_TEMPLATES,
  NEWS_PREFIX,
  PAGE_PREFIX,
  LANG_DEFAULT,
  CONSULTATIONS_STATUSES,
  HOME_SLUG,
} from '@/configs';
import classNames from 'classnames';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isToday);

export {
  get,
  fromPairs,
  isEmpty,
  isArray,
  isFunction,
  without,
  uniq,
  omit,
  pick,
  sortBy,
  flatten,
};

export const jwtDecode = (token) => {
  if (!token) return {};
  return jwt_decode(token);
};

export const setAuthTokens = ({ access, refresh, setCookie }) => {
  const jwtDecoded = jwtDecode(access);
  if (!!jwtDecoded) {
    const cookieExpiresDate = new Date(jwtDecoded.exp * 1000);
    setCookie(ACCESS_TOKEN, access, {
      path: '/',
      expires: cookieExpiresDate,
    });
    setCookie(REFRESH_TOKEN, refresh, {
      path: '/',
      expires: cookieExpiresDate,
    });
  }
};

export const removeAuthCookies = () => {
  const cookies = new Cookies();
  cookies.remove(ACCESS_TOKEN, { path: '/' });
  cookies.remove(REFRESH_TOKEN, { path: '/' });
};

export const getDate = (
  date,
  format = 'DD.MM.YYYY HH:mm',
  tz = 'Europe/Kiev'
) => {
  return !!date
    ? tz
      ? dayjs(date).tz(tz).format(format)
      : dayjs(date).format(format)
    : '-';
};

export const emptyUserImage = `/images/no-user-image.jpg`;

export const qsToObj = (qs) => {
  if (!qs || typeof qs !== 'string') return;
  const q = qs
    .replace('?', '')
    .split('&')
    .map((i) => i.split('='));
  const qz = q ? fromPairs(q) : {};
  const qzz = Object.keys(qz).reduce((obj, k) => {
    const item = qz[k].indexOf(',') > -1 ? qz[k].split(',') : qz[k];
    return { ...obj, [k]: item };
  }, {});
  return qzz;
};

export const objToQs = (qObj) => {
  return !isEmpty(qObj)
    ? Object.keys(qObj)
        .reduce((a, c) => {
          let v = qObj[c];
          v = v
            ? isArray(v)
              ? without(v, undefined, false).join(',')
              : v.hasOwnProperty('value')
              ? v.value
              : v
            : false;
          return v ? `${a}${c}=${v}&` : a;
        }, '?')
        .slice(0, -1)
    : '';
};

export const getBaseSchedulerTitle = (item) => {
  // const title = (
  //   <>
  //     <span className="event-date">{getDate(item?.start_datetime, 'HH:mm')}-{getDate(item?.end_datetime, 'HH:mm')}</span>
  //     {!!item?.specialist_name && <span className="event-psh">➟ {item?.specialist_name}</span>}
  //     {!!item?.user_name && <span className="event-user">➟ {item?.user_name}</span>}
  //   </>
  // )

  // let title = getDate(item?.start_datetime, 'HH:mm') +
  // '-' +
  // getDate(item?.end_datetime, 'HH:mm');
  // if (type === 'admin') {
  //   title += ` \r\n➟ ${item?.specialist_name}`;
  //   if (!!item?.user_name) {
  //     title += ` \r\n➟ ${item?.user_name}`;
  //   }
  // }

  const specialistName = item?.specialist_name;
  let title = `<div class="fc-event-title"><div class="event-date">${getDate(item?.start_datetime, 'HH:mm')}-${getDate(item?.end_datetime, 'HH:mm')}</div>${!!specialistName ? `<div class="event-psh">➟ ${specialistName}</div>` : ''}${!!item?.user_name ? `<div class="event-user">➟ ${item?.user_name}</div>` : ''}</div>`;
  return title;
}
export const normalizeSchedulers = (item, type = 'admin') => {
  let title = getBaseSchedulerTitle(item, type);
  const consultationStatus = item?.consultation_status || item?.consultation?.status || item?.nutrition_consultation?.status || item?.status;

  return {
    ...item,
    consultation_status: consultationStatus,
    start: item?.start_datetime,
    end: item?.end_datetime,
    classNames: classNames({
      'event-taken': item?.taken,
      'event-provided': consultationStatus === CONSULTATIONS_STATUSES.provided,
      'event-canceled': consultationStatus === CONSULTATIONS_STATUSES.canceled,
    }),
    title,
  };
};

export const getHoursFromTime = (time = '00:00') => {
  return !!time && typeof time === 'string' ? time?.split(':')[0] : 0;
};

export const showErrors = (error, actions) => {
  actions?.setErrors({
    ...(error?.errors || {}),
    details:
      error?.errors?.detail ||
      error?.errors?.non_field_errors ||
      error?.non_field_errors ||
      error?.message,
  });
};

const getDiffDates = (dateFrom, type) => {
  return dayjs().diff(dateFrom, type);
};
export const getExperience = ({ experience_years, experience, t }) => {
  if (experience_years || getDiffDates(experience, 'year')) {
    return t('years', {
      count: experience_years || getDiffDates(experience, 'year'),
    });
  }
  return t('month', { count: getDiffDates(experience, 'month') });
};

export const getCookies = () => {
  const cookies = new Cookies();
  const accessToken = cookies.get(ACCESS_TOKEN);
  const refreshToken = cookies.get(REFRESH_TOKEN);
  const lang = cookies.get(DJANGO_LANGUAGE);
  return { accessToken, refreshToken, lang };
};

export const generatePbLink = ({ id = null, cbUrl }) => {
  const { accessToken = null, refreshToken = null } = getCookies();
  let partsUrl = `${id}__${`0${accessToken}`}__${`0${refreshToken}`}`;
  if (!!cbUrl) partsUrl += `__${cbUrl}`;
  return `${process.env.REACT_APP_MAIN_SITE_URL}/pagebuilder/${partsUrl}`;
};

export const generatePagePreviewLink = ({ slug, template, locale }) => {
  const localePrefix = locale === LANG_DEFAULT ? '' : `/${locale}`;
  const typePrefix =
    template === PAGE_TEMPLATES.POST ? NEWS_PREFIX : PAGE_PREFIX;
  return `${process.env.REACT_APP_MAIN_SITE_URL}${localePrefix}/${typePrefix}/${slug}`;
};

export const generateStaticPageLink = ({ slug, locale = LANG_DEFAULT }) => {
  const localePrefix = locale === LANG_DEFAULT ? '' : `/${locale}`;
  const _slug = slug === HOME_SLUG ? '' : slug;
  return `${process.env.REACT_APP_MAIN_SITE_URL}${localePrefix}/${_slug}`;
};

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const getFileName = (filePath = '') => {
  return filePath.split('/').slice(-1)[0];
};

export const getFileType = (filePath = '') => {
  const ext = filePath.split('.').slice(-1)[0].toLowerCase();
  const defaultIcon = 'fas fa-file-upload';
  const videoIcon = 'fas fa-file-video';
  const audioIcon = 'fas fa-file-audio';
  const imageTypes = ['jpg', 'jpeg', 'png', 'webp', 'bmp', 'svg'];

  const videoExts = [
    '3g2',
    '3gp',
    'aaf',
    'asf',
    'avchd',
    'avi',
    'drc',
    'flv',
    'm2v',
    'm3u8',
    'm4p',
    'm4v',
    'mkv',
    'mng',
    'mov',
    'mp2',
    'mp4',
    'mpe',
    'mpeg',
    'mpg',
    'mpv',
    'mxf',
    'nsv',
    'ogg',
    'ogv',
    'qt',
    'rm',
    'rmvb',
    'roq',
    'svi',
    'vob',
    'webm',
    'wmv',
    'yuv',
  ];
  const audioExts = [
    'wav',
    'bwf',
    'raw',
    'aiff',
    'flac',
    'm4a',
    'pac',
    'tta',
    'wv',
    'ast',
    'aac',
    'mp2',
    'mp3',
    'amr',
    's3m',
    '3gp',
    'act',
    'au',
    'dct',
    'dss',
    'gsm',
    'm4p',
    'mmf',
    'mpc',
    'ogg',
    'oga',
    'opus',
    'ra',
    'sln',
    'vox',
  ];
  const typeMap = {
    txt: 'fas fa-file-alt',
    csv: 'fas fa-file-csv',
    pdf: 'fas fa-file-pdf',
    doc: 'fas fa-file-word',
    docx: 'fas fa-file-word',
    xls: 'fas fa-file-excel',
    xlsx: 'fas fa-file-excel',
    ppt: 'fas fa-file-powerpoint',
    pptx: 'fas fa-file-powerpoint',
  };

  let res;
  if (videoExts.includes(ext)) {
    res = videoIcon;
  } else if (audioExts.includes(ext)) {
    res = audioIcon;
  } else {
    res = get(typeMap, ext, defaultIcon);
  }

  return !!imageTypes.includes(ext) ? undefined : res;
};

export const splitIntoRows = (str) => {
  if (!str) return '';
  return str.replace(new RegExp('\r\n', 'g'), '<br />');
};
export const normalizeText = (string) => {
  return string.replaceAll('\n\n', '<br />')
}

export const getMainSiteUrl = (suffix = '') => {
  return process.env.REACT_APP_MAIN_SITE_URL + suffix;
}

export const normalizePrice = (num, digits = 2) => {
  return (Math.round(Number(num) * 100) / 100).toFixed(digits);
};

export const withHash = (value) => {
  if (!value) return ''
  const _value = value?.replaceAll('##', '#');
  return _value?.startsWith('#') ? _value : `#${_value}`;
};

export const isValidHex = (value) => {
  if (!value) return false
  const _value = value?.replaceAll('##', '#');
  const hexPattern = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/;
  return hexPattern.test(_value);
};

export const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const getMimeTypeFromFileName = (fileName) => {
  const extension = fileName.split('.').pop().toLowerCase();
  const mimeTypes = {
    mp4: 'video/mp4',
    webm: 'video/webm',
    ogg: 'video/ogg',
    mov: 'video/quicktime',
    avi: 'video/x-msvideo',
    mkv: 'video/x-matroska',
  };

  return mimeTypes[extension] || 'video/mp4';
};

export const getDiplomasSrc = (image, type = 'thumbnail') => {
  return typeof image?.file === 'string'
    ? get(image, ['file'], '')
    : get(image, ['file', type], '');
};

const SLUG_TRANSLIT_MAP = {
  а: 'a', б: 'b', в: 'v', г: 'h', ґ: 'g', д: 'd', е: 'e', є: 'ie', ё: 'e', ж: 'zh', з: 'z', и: 'y', і: 'i', ї: 'i', й: 'i',
  к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'kh', ц: 'ts', ч: 'ch',
  ш: 'sh', щ: 'shch', ъ: '', ы: 'y', ь: '', э: 'e', ю: 'iu', я: 'ia', "'": '', '’': '', 'ʼ': '',
};

export const SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const slugify = (str = '') => str
  .toLowerCase()
  .split('')
  .map((char) => SLUG_TRANSLIT_MAP[char] ?? char)
  .join('')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

export const generateSpecialistLink = ({ type, slug }) => getMainSiteUrl(`/${type}/${slug}`);
